import { render, staticRenderFns } from "./bankaposekstresi.vue?vue&type=template&id=85653acc&"
import script from "./bankaposekstresi.vue?vue&type=script&lang=js&"
export * from "./bankaposekstresi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports